// @flow

import React from 'react'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import { mediaMax } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import CheckboxWrap from 'components/molecules/SearchCheckboxWrap'
import RoomAnnotation from 'components/molecules/SearchRoomAnnotation'
import PriceAnnotation from 'components/molecules/SearchPriceAnnotation'
import { calcMapStatus } from 'helpers/search'

const MapContainer = styled.div`
  position: relative;
  height: calc(100vh - 48px);
  background-color: #eee;
  ${mediaMax.desktop`
    height: calc(100vh - 118px);
  `};
`
const MapGuide = styled.div`
  position: absolute;
  right: 48px;
  bottom: 24px;
  display: inline-block;
  width: 185px;
  height: 40px;
  padding: 12px;
  font-size: 12px;
  text-align: center;
  border: 1px solid ${Colors.grayE};
  border-radius: 3px;
  background-color: #fff;
  z-index: 1;
  cursor: pointer;
  ${mediaMax.desktop`
    bottom: 12px;
    left: 50%;
    transform: translate(-50%, 0);
  `};
`
const ReSearchButton = styled.span`
  position: absolute;
  right: 48px;
  bottom: 24px;
  display: ${props => (props.isShowReSearchButton ? 'block' : 'none')};
  width: 185px;
  height: 40px;
  padding: 12px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  border-bottom: 1px solid ${Colors.blue};
  border-radius: 3px;
  background-color: ${Colors.blueBdColor};
  z-index: 2;
  cursor: pointer;
  ${mediaMax.desktop`
    bottom: 12px;
    left: 50%;
    transform: translate(-50%, 0);
  `};
`
const MapCloseSpWrapper = styled.span`
  display: none;
  ${mediaMax.desktop`
    position: absolute;
    display: inline-block;
    top: 12px;
    right: 12px;
    cursor: pointer;
    z-index: 1;
  `};
`
const MapCloseSp = styled.span`
  position: relative;
  display: inline-block;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 4px;
  height: 28px;
  background-color: ${Colors.black};
  transform: rotate(45deg);

  &::before {
    display: block;
    content: '';
    position: absolute;
    top: 50%;
    left: -12px;
    width: 28px;
    height: 4px;
    margin-top: -2px;
    background-color: ${Colors.black};
  }
`
const ReSearchIcon = styled.i`
  margin-right: 4px;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  &::before {
    content: '\\f021';
  }
`

type PropTypes = {
  roomList: Array<{
    id: number,
    name: string,
    thumbnail: string,
    latitude: number | string,
    longitude: number | string,
    price: string,
    priceUnit: string,
    roomLink: string,
    thumbnail: string,
    isDirectReservation: boolean,
    isTopHost: boolean,
    isLastMinutesDiscount: boolean,
  }>,
  selectedRoomId: number,
  latitude: number | string,
  longitude: number | string,
  isShowRoomAnnotation: boolean,
  isShowReSearchButton: boolean,
  onClickMarker: Function,
  onClickReSearch: Function,
  onChangeMap: Function,
  onDragMap: Function,
  onChangeCheckMovingSearch: Function,
  onClickClose: Function,
  googleMapReactBootstrapURLKeys?: ?Object,
}

export default (props: PropTypes) => {
  const mapStatus = calcMapStatus(props.roomList)
  const selectedRoom = props.roomList.find(
    room => room.id === props.selectedRoomId,
  )
  return (
    <div>
      <MapContainer>
        <MapCloseSpWrapper>
          <MapCloseSp onClick={e => props.onClickClose(e)} />
        </MapCloseSpWrapper>
        <MapGuide>
          <CheckboxWrap
            item={{
              label: i18n.t('page.search.mapSearchMoving'),
              id: 'MOVING_SEARCH',
            }}
            onChange={props.onChangeCheckMovingSearch}
          />
        </MapGuide>
        <ReSearchButton
          isShowReSearchButton={props.isShowReSearchButton}
          onClick={e => {
            e.preventDefault()
            props.onClickReSearch()
          }}
        >
          <ReSearchIcon />
          {i18n.t('page.search.research')}
        </ReSearchButton>
        <GoogleMapReact
          center={mapStatus.centerLatLng}
          zoom={mapStatus.zoomLevel}
          options={{
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: true,
          }}
          onChange={props.onChangeMap}
          onDrag={props.onDragMap}
          bootstrapURLKeys={props.googleMapReactBootstrapURLKeys}
        >
          {props.roomList.map((room, index) => (
            <PriceAnnotation
              key={`PriceAnnotation${index}`}
              data-balloon-color={room.balloonColor || 'white'}
              lat={room.latitude}
              lng={room.longitude}
              onClick={() => props.onClickMarker(room)}
            >
              {room.price}
            </PriceAnnotation>
          ))}
          {selectedRoom && props.isShowRoomAnnotation ? (
            <div
              lat={parseFloat(selectedRoom.latitude)}
              lng={parseFloat(selectedRoom.longitude)}
            >
              <RoomAnnotation
                name={selectedRoom.name}
                thumbnail={selectedRoom.thumbnail}
                price={selectedRoom.price}
                priceUnit={selectedRoom.priceUnit}
                isDirectReservation={selectedRoom.isDirectReservation}
                isTopHost={selectedRoom.isTopHost}
                isLastMinutesDiscount={selectedRoom.isLastMinutesDiscount}
                roomLink={selectedRoom.roomLink}
              />
            </div>
          ) : null}
        </GoogleMapReact>
      </MapContainer>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/SearchMap/index.jsx